<template>
<div class="space-y-10">

    <tti-header></tti-header>


    <div class="bg-white ">
        <div class="mx-auto px-4 max-w-7xl sm:px-6 lg:px-8">
            <div class="space-y-12">
            <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">Who We Are</h2>

            <ul class="space-y-12 lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8 lg:gap-y-12 lg:space-y-0">
                <li>
                <div class="space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                    <div class="h-0 aspect-w-3 aspect-h-2 sm:aspect-w-3 sm:aspect-h-4">
                    <img class="object-cover shadow-lg rounded-lg" src="../assets/jasonpreece2.jpg" alt="">
                    </div>
                    <div class="sm:col-span-2">
                    <div class="space-y-4">
                        <div class="text-lg leading-6 font-medium space-y-1">
                        <h3>Dr Jason Preece</h3>
                        <a href="mailto:jason@thetutorindex.com" class="text-blue-600 hover:underline">jason@thetutorindex.com</a>
                        </div>
                        <div class="text-lg">
                        <p class="text-gray-500">Jason has been teaching and tutoring for ten years, initially using the income to pay for his postgraduate studies at Oxford University. He has taught across a wide range of subjects but focuses primarily on Music and Maths.</p>
                        </div>
                    </div>
                    </div>
                </div>
                </li>

                <li>
                <div class="space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                    <div class="h-0 aspect-w-3 aspect-h-2 sm:aspect-w-3 sm:aspect-h-4">
                    <img class="object-cover shadow-lg rounded-lg" src="../assets/chrisnicholson.jpg" alt="">
                    </div>
                    <div class="sm:col-span-2">
                    <div class="space-y-4">
                        <div class="text-lg leading-6 font-medium space-y-1">
                        <h3>Chris Nicholson</h3>
                        <a href="mailto:chris@thetutorindex.com" class="text-blue-600 hover:underline">chris@thetutorindex.com</a>
                        </div>
                        <div class="text-lg">
                        <p class="text-gray-500">Chris has a background in tech, with nearly 15 years experience and a large portfolio of websites, software, and apps. He has both setup and worked for a number of startup and small businesses, many of which are market-leaders in their respective fields.</p>
                        </div>
                    </div>
                    </div>
                </div>
                </li>
            </ul>
            </div>
        </div>
        </div>


    <tti-footer></tti-footer>

</div>
</template>
<script>
export default {
    components: {
        'tti-header': () => import('./HeaderNew'),
        'tti-footer': () => import('./Footer')
    }
}
</script>